/** @jsx jsx */

import * as React from "react";
import { css, jsx } from "@emotion/core";
import { Main } from "Views/scaffolding/layouts/main/main";
import { BaseLayout } from "./base";
import { HeroHOC } from "Views/scaffolding/layouts/hero_hoc";
require("Views/assets/sandpipers_large.jpg");
require("Views/assets/sandpipers_small.jpg");

/** Props needed for rendering a page with the Heroic layout. */
export type HeroicLayoutProps = React.PropsWithChildren<{}>;

function heroicLayout(props: HeroicLayoutProps): JSX.Element {
  const { children } = props;
  return (
    <BaseLayout>
      <HeroHOC
        srcSmall="/wp-content/themes/sandpiper/img/sandpipers_small.jpg"
        srcLarge="/wp-content/themes/sandpiper/img/sandpipers_large.jpg"
        srcAltText="The Sandpiper Nursery School"
      />
      <Main>{children}</Main>
    </BaseLayout>
  );
}

const heroicLayoutMemo = React.memo<HeroicLayoutProps>(heroicLayout);
export { heroicLayoutMemo as HeroicLayout };
